import { EventToCalendarAssociation } from '../schema/EventToCalendarAssociation';
import { trace } from 'owa-trace';

let eventToCalendarAssociation: EventToCalendarAssociation = null;

export const getEventToCalendarAssociation = () => {
    if (!eventToCalendarAssociation) {
        trace.warn('EventToCalendarAssociation is not initialized');
        return null;
    }

    return eventToCalendarAssociation;
};

export const initializeEventToCalendarAssociation = (lookup: EventToCalendarAssociation) => {
    if (eventToCalendarAssociation) {
        trace.warn('EventToCalendarAssociation already initialized');
        return;
    }
    eventToCalendarAssociation = lookup;
};
